import React from 'react'
import PropTypes from 'prop-types'
import {Stack} from '@chakra-ui/layout'
import {Button, Link} from '@chakra-ui/react'
import {useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'
import {
    A3EnergyIcon,
    A2EnergyIcon,
    A1EnergyIcon,
    AEnergyIcon,
    BEnergyIcon,
    CEnergyIcon,
    DEnergyIcon,
} from '../icons'

const EnergyLabel = ({
    description,
    level,
    manualDocument,
    labelPosition = 'top',
    iconSize = 'big',
    textWidth = 'big',
    textSize = 'big',
    width = 'unset',
    justifyContent = 'unset',
    extraStyleDescription = {},
}) => {
    const style = useMultiStyleConfig('EnergyLabel', {
        labelPosition,
        iconSize,
        textWidth,
        textSize,
        width,
        justifyContent,
    })

    const intl = useIntl()

    const levelComponents = {
        'A+++': A3EnergyIcon,
        'A++': A2EnergyIcon,
        'A+': A1EnergyIcon,
        A: AEnergyIcon,
        B: BEnergyIcon,
        C: CEnergyIcon,
        D: DEnergyIcon,
    }
    const LevelComponent = levelComponents[level]

    const manualDocumentInfo = manualDocument && JSON.parse(manualDocument)

    const energyLabelDoc = manualDocumentInfo?.find((doc) => doc?.isEnergyLabel === 'true')
    const energyLabelProps = energyLabelDoc?.imageLink
        ? {
              as: 'a',
              href: energyLabelDoc.imageLink.replace(/&download=true/, ''),
              target: '_blank',
              rel: 'noopener noreferrer',
              'aria-label': intl.formatMessage(
                  {
                      id: 'energy_label.aria_label',
                      defaultMessage: 'Energy efficiency {level}{clickAction}',
                      description: 'Accessibility label for energy efficiency button',
                  },
                  {
                      level,
                      clickAction: energyLabelDoc?.imageLink
                          ? intl.formatMessage({
                                id: 'energy_label.click_action',
                                defaultMessage: ', click to view energy label',
                            })
                          : '',
                  },
              ),
          }
        : {}

    const productFicheDoc = manualDocumentInfo?.find((doc) => doc?.isProductFiche === 'true')
    const productFicheProps = productFicheDoc?.imageLink
        ? {
              href: productFicheDoc.imageLink.replace(/&download=true/, ''),
              target: '_blank',
              rel: 'noopener noreferrer',
              'aria-label': intl.formatMessage(
                  {
                      id: 'product_fiche.aria_label',
                      defaultMessage: 'Product fiche {clickAction}',
                      description: 'Accessibility label for product fiche link',
                  },
                  {
                      clickAction: productFicheDoc?.imageLink
                          ? intl.formatMessage({
                                id: 'product_fiche.click_action',
                                defaultMessage: ', click to view product fiche',
                            })
                          : '',
                  },
              ),
          }
        : {}
    return (
        <Stack {...style.container}>
            {productFicheDoc?.imageLink && (
                <Link {...style.description} {...extraStyleDescription} {...productFicheProps}>
                    {description}
                </Link>
            )}
            <Button {...style.labelIcon} {...energyLabelProps}>
                {LevelComponent && <LevelComponent {...style.icon} />}
            </Button>
        </Stack>
    )
}

EnergyLabel.propTypes = {
    description: PropTypes.string,
    manualDocument: PropTypes.string,
    level: PropTypes.string,
    labelPosition: PropTypes.oneOf(['top', 'left']),
    iconSize: PropTypes.oneOf(['big', 'small']),
    textWidth: PropTypes.oneOf(['big', 'medium', 'small']),
    textSize: PropTypes.oneOf(['big', 'small']),
    justifyContent: PropTypes.string,
    width: PropTypes.string,
    extraStyleDescription: PropTypes.object,
}

export default EnergyLabel
